import React, { useState, useEffect, forwardRef } from 'react';

import styles from './styles.module.scss';

import { useContext } from 'react';

import 'moment/locale/fa';

import Cookies from 'js-cookie';
import Api from '../../api';
import Loader from '../Loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import SHARED from '../../constants';
import AppIcons from '../../icons';

import FileTypeComponent from '../FileTypeComponent';
import FileTypesContainer from '../FileTypesContainer';
import { AdminContext } from '../../context/AdminContext';
import ThemeBox from '../ThemeBox';
import LanguageBox from '../LanguageBox';
import BackgroundBox from '../BackgroudBox';
import AppSwitch from '../AppSwitch';
import FileSection from '../FileSection';
import UpdateProfileModal from '../UpdateprofileModal';
import CookieFunction from '../../functions/cookieFunction';
import useWindowDimensions from '../../functions/UseWindowDimensions';
import CenterModal from '../CenterModal';
import ConfirmationButton from '../ConfirmationButton';
import packageInfo from '../../../../package.json';
import ChangePassword from '../ChangePassword';

const SettingModal = forwardRef((props, ref) => {
  const [serverError, setServerError] = useState('');

  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [count, setCount] = useState(0);
  const [showConfirm, setShowConfirm] = useState(false);
  // const {version } from '../../../../package.json';
  const [activePlayer, setActivePlayer] = useState();
  const {
    activeMessage,
    setActiveMessage,
    activeUser,
    setActiveAudio,
    isLogin,
    userInfo,
    setUserInfo,
    content,
    lang,
    themeMode,
    setThemeMode,
    activeMenuFile,
    setActiveMenuFile,
    direction,
  } = useContext(AdminContext);
  const [activeMenu, setActiveMenu] = useState(activeMenuFile?.tab?.[0]);

  const [onlineStatus, setOnlineStatus] = useState(
    userInfo?.securityStatusId == 2 ? false : true
  );
  const [mode, setMode] = useState(themeMode == 'dark' ? true : false);
  const { width, height } = useWindowDimensions();
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    setShowContent(width <= 650 ? false : true);
    setActiveMenu(activeMenuFile?.tab?.[0]);
  }, [width]);

  useEffect(() => {
    if (window?.innerWidth <= 650) {
      setShowContent(false);
    }
  }, []);

  const changeOnlineStatus = () => {
    Api.onlineStatus({ params: { onlineStatus: !onlineStatus } })
      .then((res) => {
        setOnlineStatus(!onlineStatus);

        setUserInfo({
          ...userInfo,
          securityStatusId: userInfo?.securityStatusId == 2 ? 1 : 2,
        });
      })
      .catch((err) => {});
  };
  const onChangeThemeMode = () => {
    setMode(!mode);
  };
  useEffect(() => {
    let x = mode ? 'dark' : 'white';
    CookieFunction('set', 'ochattMode', x, () => {
      setThemeMode(CookieFunction('get', 'ochattMode'));
    });
  }, [mode]);
  console.log('files', files, content?.folderPart?.menu);
  console.log('activeMenu', activeMenu);
  useEffect(() => {
    setActiveMenu(
      content.settingModal?.menu[
        content.settingModal?.menu?.findIndex((x) => x.id == activeMenu?.id)
      ]
    );
  }, [lang, content]);
  useEffect(() => {
    setActiveMenu(activeMenuFile?.tab?.[0]);
    if (activeMenu != undefined) {
      setShowContent(true);
    }
    // setShowContent(true);
  }, [activeMenuFile]);
  console.log(
    'mode',
    mode,
    CookieFunction('get', 'ochattMode'),
    themeMode,
    showContent,
    width
  );
  const deleteAccount = () => {
    Api.deleteAccount()
      .then((res) => {
        // props?.exitFunction();
        setActiveMessage('');
        setActiveAudio();
        CookieFunction('remove', 'ochattToken');
        CookieFunction('remove', 'userAuthOchatt');
        CookieFunction('remove', 'userName');
      })
      .cxatch((err) => {});
  };
  console.log('showContent', showContent, width, activeMenuFile, activeMenu);
  return (
    <div
      className={` flex flex-row justify-start items-start w-full h-full relative ${styles.container}`}
    >
      {((!showContent && width <= 650) || width > 650) && (
        <div
          className={`${styles.menu} ${
            direction == 'rtl' ? styles.menuBorderLeft : styles.menuBorderRight
          } ${themeMode == 'dark' && styles.dark}`}
        >
          <AppSwitch
            extraClassName={styles.menuItem}
            text={`${content?.onlineStatus}`}
            description={
              onlineStatus ? content?.onlineStatusOn : content?.onlineStatusOff
            }
            state={onlineStatus}
            onClick={() => {
              changeOnlineStatus();
            }}
          />
          <AppSwitch
            extraClassName={styles.menuItem}
            text={`${content?.darkMode}`}
            description={mode ? content?.darkModeOn : content?.darkModeOff}
            state={mode}
            onClick={() => {
              onChangeThemeMode();
            }}
          />
          {content?.settingModal?.menu?.map((item, index) => (
            <div
              className={`flex flex-row justify-between items-center w-full h-auto ${
                styles.singleMenu
              } ${
                activeMenu?.id == item?.id
                  ? `${'activeUserBox'} ${styles.activeBoxBorderRadius}  `
                  : 'unActiveUserBox'
              }`}
              onClick={() => {
                setActiveMenu(item);
                setShowContent(true);
                if (item?.id == 6) {
                  props?.exitFunction();
                  setActiveMessage('');
                  setActiveAudio();
                }
                if (item?.id == 7) {
                  setShowConfirm(true);
                }
              }}
            >
              <p
                key={index}
                className={` ${styles.menuItem}
              `}
              >
                {item?.name}
              </p>
              {item?.icon}
            </div>
          ))}
          <div
            className={`flex flex-row justify-between items-center w-full h-auto mt-auto ${styles.version} flex-wrap`}
          >
            <a
              href="https://ochatt.com"
              target={'_blank'}
              className={`linkStyle`}
              title="Ochatt"
            >
              https://ochatt.com
            </a>
            <div className={``}>{`v${packageInfo?.version}`}</div>
          </div>
        </div>
      )}
      {((showContent && width <= 650) || width > 650) && (
        <div
          className={`flex flex-row justify-start items-start  box-border mr-auto pb-6 ${
            styles.flexStyle
          } ${themeMode == 'dark' && styles.dark} ${
            themeMode != 'dark'
              ? 'message__containerScrollbarW'
              : 'message__containerScrollbarD'
          } `}
          id="scrollableDiv"
          style={{
            // minHeight: '80%',
            height: '100%',
            // width: '75%',
            overflowY: 'auto',
          }}
        >
          <div
            className={`flex flex-col justify-start items-start box-border ${styles.sideWidth} w-[100%] h-[100%] px-6`}
          >
            {serverError !== '' && (
              <div className={styles.serverError}>
                <AppImage
                  src="/imgs/login/warning.svg"
                  alt="warning"
                  width={20}
                  height={20}
                  containerclassName="flex flex-row justify-center items-center"
                />
                <span>{serverError}</span>
              </div>
            )}
          </div>
          {loading ? (
            <Loader width={`w-full h-400px `} />
          ) : (
            <>
              <div
                className={`${styles.content} ${
                  showContent && width <= 650 && styles.mobileContent
                } ${
                  themeMode != 'dark'
                    ? 'message__containerScrollbarW'
                    : 'message__containerScrollbarD'
                } `}
              >
                <>
                  {activeMenu?.id && activeMenu?.id != 6 && (
                    <div className={`${styles.header} borderBottom`}>
                      <p>{activeMenu?.name}</p>
                      {showContent && width <= 650 && (
                        <AppIcons.ArrowLeftIconGray
                          onClick={() => {
                            setShowContent(false);
                            setActiveMenu();
                            // setActiveMenuFile();
                            // setActiveMenuFile({
                            //   tab: content.settingModal?.menu[
                            //     content.settingModal?.menu?.findIndex(
                            //       (x) => x.id == activeMenu?.id
                            //     )
                            //   ],
                            //   subMenu: 1,
                            // });
                          }}
                          className={`${
                            direction == 'ltr' && 'rotate-180'
                          } cursor-pointer ${styles.arrow}`}
                          width={12}
                          height={16}
                        />
                      )}
                    </div>
                  )}
                  {activeMenu?.id == 1 && <ThemeBox content={content} />}
                  {activeMenu?.id == 2 && <LanguageBox />}
                  {activeMenu?.id == 3 && <BackgroundBox />}
                  {activeMenu?.id == 4 && <FileSection content={content} />}
                  {activeMenu?.id == 8 && <ChangePassword content={content} />}
                  {activeMenu?.id == 5 && (
                    <UpdateProfileModal
                      content={content}
                      ref={ref}
                      informLeftUser={props?.informLeftUser}
                      updateUser={props?.updateUser}
                      buttonText={activeMenu?.name}
                    />
                  )}
                  {activeMenu?.id == 7 && (
                    <div className={styles.confirmModalContainer}>
                      {/* <p className={styles.title}>ghgh</p> */}
                      <p className={styles.text}>
                        {content?.deleteAccount?.description}
                      </p>
                      <ConfirmationButton
                        confirmText={content?.deleteAccount?.confirmText}
                        rejectText={content?.deleteAccount?.rejectText}
                        confirmFunction={() => {
                          deleteAccount();
                          setActiveMessage('');
                          setActiveAudio();
                          setShowConfirm(false);
                        }}
                        rejectFunction={() => {
                          setShowConfirm(false);
                          setActiveMessage('');
                          setActiveAudio();
                          setShowContent(false);
                          setActiveMenu();
                        }}
                      />
                    </div>
                  )}
                </>
              </div>
            </>
          )}
        </div>
      )}
      {/* {showConfirm && (
        <CenterModal
          handleShowModal={() => {
            setShowConfirm(false);
          }}
          extraContentStyle={`confirmDeleteModal`}
        >
          <div className={styles.confirmModalContainer}>
            <p className={styles.title}>ghgh</p>
            <p className={styles.text}>dfgdf</p>
            <ConfirmationButton
              confirmText={`yes`}
              rejectText={`no`}
              confirmFunction={() => {
                deleteAccount();
                setActiveMessage('');
                setActiveAudio();
                setShowConfirm(false);
              }}
              rejectFunction={() => {
                setShowConfirm(false);
                setActiveMessage('');
                setActiveAudio();
              }}
            />
          </div>
        </CenterModal> */}
      {/* )} */}
    </div>
  );
});

export default SettingModal;
